import _ from "lodash";
import React from "react";

import NO_IMAGE_AVAILABLE from "@assets/images/NO_IMAGE_AVAILABLE.jpg";

const { REACT_APP_API_ENDPOINT } = process.env;

export const Image = ({ attribute }) => {
  console.log("attribute :>> ", attribute);
  const objectFit = _.get(attribute, ["objectFit"], "full"); // contain , cover , fill
  const path = `${REACT_APP_API_ENDPOINT}/${_.get(attribute, ["path"])}`;

  return (
    <img
      style={{
        width: "100%",
        height: "100%",
        objectFit: objectFit,
      }}
      src={path}
      alt={"get-led"}
      onError={({ target }) => {
        target.onerror = null;
        target.src = NO_IMAGE_AVAILABLE;
        target.style.objectFit = "cover"; // auto cover when load image error
      }}
    />
  );
};
